import { createApp } from '@backstage/frontend-defaults';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import appVisualizerPlugin from '@backstage/plugin-app-visualizer';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import {
  techDocsExpandableNavigationAddonModule,
  techDocsLightBoxAddonModule,
  techDocsReportIssueAddonModule,
  techDocsTextSizeAddonModule,
} from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import githubDeploymentsPlugin from '@backstage-community/plugin-github-deployments/alpha';
import { authModule } from './modules/auth';
import { githubPRModule } from './modules/githubPR';
import { homeModule } from './modules/home';
import { navModule } from './modules/nav';

export default createApp({
  features: [
    apiDocsPlugin,
    appVisualizerPlugin,
    catalogPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    homePlugin,
    orgPlugin,
    scaffolderPlugin,
    searchPlugin,
    techdocsPlugin,
    techDocsExpandableNavigationAddonModule,
    techDocsLightBoxAddonModule,
    techDocsReportIssueAddonModule,
    techDocsTextSizeAddonModule,
    userSettingsPlugin,
    githubDeploymentsPlugin,
    authModule,
    githubPRModule,
    homeModule,
    navModule,
  ],
});
